import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import axios from "axios";
import CountUp from "react-countup";
import Widget from "../../../../../components/Widget/Widget";

const PageImpressions = () => {
  const [impressionsData, setImpressionsData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async (firstLoad) => {
    if(firstLoad){
      setLoading(true);
    }
    try {
      const response = await axios.get(
        "https://eadash.arabiansystems.com/api/Analytics/socialMedia"
      );
      const data = response.data.socialMedia;
      setImpressionsData(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(true);
    const interval = setInterval(() => {
      fetchData(false);
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Widget fetchingData={loading}>
      <div className="clearfix height150">
        <Row className="flex-nowrap">
          <Col xs={3}>
          <img src="/icons/impression.png" width={window.innerWidth < 1576 ? "40" : "60"} />

          </Col>
          <Col xs={9}>
            <h6 className="m-0">Total Impressions</h6>
            <p className="h2 m-0 fw-normal">
              <CountUp
                start={0}
                end={impressionsData?.impressions}
                duration={2}
                separator=","
                enableScrollSpy
              />
            </p>
          </Col>
        </Row>
        <Row className="flex-nowrap marginTop36">
          <Col xs="6">
            <h6 className="m-0">Clicks</h6>
            <p className="value5">
              <CountUp
                start={0}
                end={impressionsData?.clicks}
                duration={2}
                separator=","
                enableScrollSpy
              />
            </p>
          </Col>
          <Col xs={6}>
            <h6 className="m-0">Engagement</h6>
            <p className="value5">
              <CountUp
                start={0}
                end={impressionsData?.engagement}
                duration={2}
                separator=","
                enableScrollSpy
              />
            </p>
          </Col>
          {/* <Col xs={4}>
            <h6 className="m-0">Rating</h6>
            <p className="value5">
              <CountUp
                start={0}
                end={impressionsData?.ctr}
                duration={2}
                separator=","
                enableScrollSpy
              />%
            </p>
          </Col> */}
        </Row>
        <Row>
          <Col xs={12}>
            <div className="marginTop10 infoFlex">
              <i class="fa fa-info-circle"></i>
              <p className="m-0">Based on data from the last 30 days</p>
            </div>
          </Col>
        </Row>
      </div>
    </Widget>
  );
};

export default PageImpressions;
